export default "__VITE_ASSET__CJ75lnOZ__"